// extracted by mini-css-extract-plugin
var _1 = "PostHistoryView-module__controlBar--kItNI";
var _2 = "PostHistoryView-module__emptyStateContainer--vAW1U";
var _3 = "PostHistoryView-module__footerControlBar--pvgKW";
export { _1 as "controlBar", _2 as "emptyStateContainer", _3 as "footerControlBar" }
